import { Schema } from "effect";

export const OptionalBooleanString = Schema.Literals([
  "true",
  "false",
  "1",
  "0",
]);

export const normalizeOptionalEnv = (
  value?: string
): string | undefined => {
  if (value === undefined) {
    return undefined;
  }

  return value.trim().length > 0 ? value : undefined;
};

export const parseBooleanEnv = (
  fallback: boolean,
  value?: Schema.Schema.Type<typeof OptionalBooleanString>
): boolean => {
  if (value === undefined) {
    return fallback;
  }

  return value === "true" || value === "1";
};
